// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3tMP1","options":"AnswerScale_options__88fbd","selected":"AnswerScale_selected__3AvZ7"};